export default __webpack_public_path__ + "static/media/ticket3.c6fb7785.svg";